import React, {useCallback, useMemo} from "react";
import {useHistory, useParams} from "react-router-dom";
import ViewIcon from "../../assets/image/icon_eye.svg"
import Split from "../../assets/image/split.svg"
import useFetch from "@common/hooks/fetch/useFetch";
import {Moments} from "@common/utils/date/moments";
import Prev from "../../assets/image/icon_prev.svg";
import {getThemeAdList} from "@common/services/restapi/theme";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {convertPath} from "@common/utils/path/linkPath";

function ThemeAdDetailView() {

  const history = useHistory();
  const { themeId } = useParams();

  const handleGoBack = useCallback(() => {
    history.goBack();
  },[]);

  const themeAdSearchQuery = useMemo(() => {
    return {
      id: themeId,
      pageNumber: 1,
      pageSize: 12
    }
  }, [])

  const {data: themeAdList} = useFetch(() => getThemeAdList(themeAdSearchQuery), [themeAdSearchQuery], {})

  return (
    <>
      <div className="common-header--top">
        <a className="prev-btn" onClick={handleGoBack}>
          <img src={Prev} alt=""/>
        </a>
        <h3 className="header-title">테마 광고</h3>
      </div>
      <section className="common-body--list">
        {
          themeAdList.themeTitle &&
          <div className="row-box">
            <h4 className="headline">{themeAdList.themeTitle}</h4>
          </div>
        }
        {/*<div className="btn-box">
        <button className="random">
          <img src={Suffle} alt=""/> 랜덤 재생
        </button>
        <button className="relay">
          <img src={Relay} alt=""/> 순차 재생
        </button>
      </div>*/}

          <div className="row-box">
            <div className="video-count">동영상 <span>{themeAdList.totalCount}</span>개</div>
          </div>
        {
          themeAdList.recommendThemeAdList && themeAdList.recommendThemeAdList.length > 0 &&
            <div className="ad-list">
              {
                themeAdList.recommendThemeAdList.map((theme, i) =>  (
                  <a href={convertPath(`/ad/${theme.adCategory}/${theme.adId}`)} className="ad-box small-horizontal" key={`theme-${i}`}>
                    <div className="thumbnail-card-wrapper">
                      <LazyLoadImage className="thumbnail-card small-video" src={`${theme.ad.thumbnail.replace('/l/', '/m/').replace("http:", "https:")}`}/>
                    </div>
                    <div className="ad-info">
                      <h4 className="title">{theme.ad.title}</h4>
                      <h5 className="company">{theme.ad.brand}</h5>
                      <div className="row-box">
                        <div className="view-count">
                          <img src={ViewIcon} alt=""/>
                          <span>{theme.ad.rcount}</span>
                        </div>
                        <img src={Split} alt=""/>
                        <div className="created-date">{Moments.Format(theme.ad.wdate, 'yyyy.MM.DD')}</div>
                      </div>
                    </div>
                  </a>
                ))
              }
            </div>
        }
      </section>
    </>
  )
}

export default ThemeAdDetailView;
